var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrokenImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m264.2 430h-204.94c-32.66 0-59.23-26.57-59.23-59.23v-229.54c-.01-32.66 26.57-59.23 59.23-59.23h205.96c3.13 0 5.97 1.82 7.27 4.67 1.3 2.84.83 6.19-1.22 8.56l-61.76 71.6c-2.66 3.08-2.73 7.61-.17 10.76l52.45 64.79c7.42 9.17 7.23 22.32-.47 31.26l-51.66 60.01c-2.7 3.13-2.73 7.71-.07 10.87l60.72 72.33c2 2.38 2.44 5.71 1.12 8.52s-4.12 4.63-7.23 4.63z",
    fill: "#d5dadd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m452.74 430h-138.99l-63.68-75.85c-7.4-8.82-7.32-21.55.19-30.27l52.78-61.32c2.33-2.7 2.39-6.67.14-9.45l-52.99-65.45c-7.43-9.18-7.23-22.34.49-31.28l64.16-74.38h137.9c32.66 0 59.23 26.57 59.23 59.23v229.53c.01 32.67-26.57 59.24-59.23 59.24z",
    fill: "#d5dadd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m452.74 430h-138.99l-63.68-75.85c-7.4-8.82-7.32-21.55.19-30.27l52.78-61.32c2.06-2.39 2.36-5.82.76-8.54l-2.94-4.98 30.17-34.51c6.07-6.94 14.84-10.93 24.07-10.94h.02c9.22 0 17.99 3.97 24.06 10.91l132.79 151.47v4.8c.01 32.66-26.57 59.23-59.23 59.23z",
    fill: "#5b738b"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m169.52 430h-110.26c-32.66 0-59.23-26.57-59.23-59.23v-1.74c0-1.94.7-3.81 1.98-5.27l73.31-83.85c6.07-6.94 14.84-10.93 24.07-10.94h.02c9.22 0 17.99 3.97 24.06 10.91l75.21 85.79c10.16 11.59 12.52 27.52 6.16 41.56-6.37 14.05-19.9 22.77-35.32 22.77z",
    fill: "#8396a8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m264.2 430h-120.7c-9.54 0-17.91-5.39-21.85-14.08-3.94-8.68-2.49-18.54 3.79-25.72l126.32-144.48c1.79-2.05 4.5-3.05 7.2-2.65 2.69.4 5 2.14 6.12 4.62 3.88 8.61 2.41 18.79-3.75 25.95l-51.66 60.01c-2.7 3.13-2.73 7.71-.07 10.87l60.72 72.33c2 2.38 2.44 5.71 1.12 8.52s-4.13 4.63-7.24 4.63z",
    fill: "#5b738b"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m170.77 217.48c-21.7 0-39.35-17.65-39.35-39.35s17.65-39.35 39.35-39.35c16.49 0 31.36 10.41 36.99 25.9.6 1.65.64 3.45.12 5.12-.73 2.34-.41 4.88.89 6.95.93 1.48 1.34 3.23 1.19 4.97-1.85 20.39-18.7 35.76-39.19 35.76z",
    fill: "#a9b4be"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrokenImage);
export default __webpack_public_path__ + "static/media/broken-image.840d02644f0e1238a461b734a7238074.svg";
export { ForwardRef as ReactComponent };